import { render, staticRenderFns } from "./filterpage.vue?vue&type=template&id=bc7b525a&"
import script from "./filterpage.vue?vue&type=script&lang=js&"
export * from "./filterpage.vue?vue&type=script&lang=js&"
import style0 from "./filterpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports